import { useMemo } from 'react';

import { useOfflineQueue } from '../offline';

export const useFreshDetailQueryOptions = ({ noCache = false } = {}) => {
	const { isReady, isOnline } = useOfflineQueue();

	const detailQueryOptions = useMemo(() => ({
		fetchPolicy: noCache ? 'no-cache' : 'cache-and-network',
		nextFetchPolicy: noCache ? 'no-cache' : 'cache-and-network',
	}), [noCache]);

	return {
		canRenderDetailQuery: isReady,
		detailQueryOptions,
		blockDataWhileLoading: isReady && isOnline,
	};
};
